<div class="menu-footer">
  @if (isImpersonating()) {
    <div class="impersonating-chip" role="status" aria-label="Impersonando">
      Impersonando
    </div>
  }
  <div class="menu-divider"></div>
  @defer {
    <div
      class="additional-menu"
      [ngClass]="{ 'additional-menu-no-padding': !isExpanded }">
      <div
        class="menu-item"
        [ngClass]="{ 'no-expanded-menu-item': !isExpanded }">
        <span class="material-symbols-rounded"> notifications_unread </span>
        <a
          (click)="openNotificationsPanel()"
          appTooltipEllipsis
          (appTruncateTextChange)="appTruncateText = $event"
          >Notificaciones</a
        >
      </div>
      <div
        class="menu-item"
        [ngClass]="{ 'no-expanded-menu-item': !isExpanded }">
        <span class="material-symbols-rounded"> help </span>
        <a
          (click)="mensajeASoporteModal()"
          appTooltipEllipsis
          (appTruncateTextChange)="appTruncateText = $event"
          >Soporte</a
        >
      </div>
      <div
        class="menu-item user-menu"
        [class.user-menu-name-only]="!userRole()"
        [ngClass]="{
          'no-expanded-menu-item': !isExpanded,
          active: isUserMenuOpen(),
        }">
        <span class="material-symbols-rounded"> account_circle </span>
        <div class="user-menu-container">
          <a
            #userMenuTrigger
            class="user-menu-trigger"
            (click)="toggleUserMenu()"
            appTooltipEllipsis
            (appTruncateTextChange)="appTruncateText = $event">
            <div class="user-name-role">
              <span class="user-name-text">{{ userName() || 'Usuario' }}</span>
              @if (userRole()) {
                <span class="textos-body-small user-name-role-subtitle">{{
                  userRole()
                }}</span>
              }
            </div>
            <span
              class="material-symbols-rounded dropdown-icon"
              [ngClass]="{ rotated: isUserMenuOpen() }">
              chevron_right
            </span>
          </a>

          <div class="user-submenu" [ngClass]="{ open: isUserMenuOpen() }">
            <div class="submenu-item">
              <span class="material-symbols-rounded"> settings </span>
              <a
                class="logout-button"
                (click)="goToConfig()"
                appTooltipEllipsis
                (appTruncateTextChange)="appTruncateText = $event">
                Configuración
                @if (isLoadingLogout()) {
                  <app-load-spinner size="20"></app-load-spinner>
                }
              </a>
            </div>
            <div class="submenu-item">
              <span class="material-symbols-rounded"> map </span>
              <a
                class="logout-button"
                (click)="goToObtenerGeojson()"
                appTooltipEllipsis
                (appTruncateTextChange)="appTruncateText = $event">
                Obtener Geojson
              </a>
            </div>
            @if (canSwitchUser()) {
              <div class="submenu-item">
                <span class="material-symbols-rounded"> swap_horiz </span>
                <a
                  class="logout-button"
                  (click)="switchUser()"
                  appTooltipEllipsis
                  (appTruncateTextChange)="appTruncateText = $event">
                  Cambiar de usuario
                </a>
              </div>
            }
            <div class="submenu-item">
              <span class="material-symbols-rounded"> logout </span>
              <a
                class="logout-button"
                (click)="!isLoadingLogout() && logout()"
                [class.disabled]="isLoadingLogout()"
                [attr.aria-disabled]="isLoadingLogout()"
                appTooltipEllipsis
                (appTruncateTextChange)="appTruncateText = $event">
                Cerrar sesión
                @if (isLoadingLogout()) {
                  <app-load-spinner size="20"></app-load-spinner>
                }
              </a>
            </div>
          </div>
        </div>
      </div>
      @if (companyId() !== 1) {
        <div class="menu-item company-name">
          <span class="textos-body-medium">{{ companyName() }}</span>
        </div>
      }
    </div>
  } @placeholder {
    <div style="padding: 10px">
      <ngx-skeleton-loader
        class="additional menu"
        [count]="3"
        [appearance]="'line'"
        [theme]="{
          'border-radius': '10px',
          height: '40px',
        }">
      </ngx-skeleton-loader>
    </div>
  }
</div>
